import React from 'react';
import classNames from 'classnames';

import type { FontType } from '../types';

import styles from './DropDownFont.module.scss';

type FontsListPropsType = {
  items: FontType[];
  onSelect: (item: FontType) => void;
  selectedFont: string;
};

const List: React.FC<FontsListPropsType> = ({ items, onSelect, selectedFont }) => (
  <div className={styles.fontList}>
    {items.map((item) => (
      <div
        key={item.key}
        className={classNames(styles.fontItem, styles[item.key], { [styles.isSelected]: selectedFont === item.value })}
        onClick={() => onSelect(item)}
      >
        {item.value}
      </div>
    ))}
  </div>
);

export const FontsList = React.memo(
  List,
  (prevProps, nextProps) => prevProps.items === nextProps.items && prevProps.selectedFont === nextProps.selectedFont,
);
